<template>
    <tasks-get
        :page="page"
        :archived="archived"
        :include="[
            'tenancy(include:property(include:address))',
        ]"
        v-slot="{
            data: tasks,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint
                v-if="$gate.role('landlord')"
                name="landlords-tasks-index"
            >
                <template slot="heading">
                    Tasks
                </template>

                <p>
                    We automatically create tasks to help you keep on track with managing your portfolio on Rentora.
                </p>
            </base-hint>

            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 py-3 sm:px-6 border-b-3 border-grey-bg">
                    <div class="flex-grow">
                        <h1 class="py-2 text-lg font-normal md:py-3">Tasks</h1>
                    </div>

                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full text-grey"
                        />
                    </div>

                    <div class="flex-none">
                        <router-link
                            :to="{
                                name: $router.fix('dashboard.*.tasks.create')
                            }"
                            class="btn btn-sm btn-with-icon"
                        >
                            <div class="flex items-center justify-center">
                                <base-svg
                                    name="icon-add-circle"
                                    class="w-6 h-6 md:mr-2"
                                />
                                <div class="hidden md:block">New Task</div>
                            </div>
                        </router-link>
                    </div>
                </header>

                <template v-if="meta.count > 0">
                    <tasks-list
                        :tasks="tasks"
                        @success="get"
                    />

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            No tasks
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>You haven't got anything to do!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tasks-get>
</template>

<script>
    import PaginationMixin from '../../../../mixins/pagination'
    import TasksGet from '../../../../components/tasks-get'
    import TasksList from '../../../../components/tasks-list'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            TasksGet,
            TasksList
        }
    }
</script>
